import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import { EditarMotivoPago, GuardarMotivoPago } from "../../../../API/RRHH/Maestros/MaestrosRequest";


const MotivosPagoCRUD = ({
  showDialog,
  setShowDialog,
  getInfo,
  selected,
  setSelected,
  modo
}) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [responsabilidad, setResponsabilidades] = useState([]);
  const [habilidades, setHabilidades] = useState([]);
  const [monedas, setMonedas] = useState([]);

  const initialValues = {
    IdMotivoPago: -1,
    MotivoPago: "",
    Comentario: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const monedasTempo = await ObtenerCurrency("General");
    setMonedas(monedasTempo);

    if(selected[0]?.IdMotivoPago > 0){
      setValues({
        ...selected[0],
      });
    }else{
      setValues(initialValues);
    }

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.MotivoPago) {
      error.MotivoPago = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const Datos = {
        IdMotivoPago: selected[0]?.IdMotivoPago ? selected[0]?.IdMotivoPago : -10,
        MotivoPago: values?.MotivoPago,
        Comentario: values?.Comentario,
        IdUserEdit: userAuth?.IdUser,
      };

      if(Datos.IdMotivoPago > 0){
        setLoading(true)
        const resultado = await EditarMotivoPago(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarMotivoPago(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Editar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarDatos();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Motivo de Pago" : "Editar Motivo de Pago";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="MotivoPago"
                    value={values.MotivoPago}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.MotivoPago ? "p-invalid" : ""}
                  />
                  <label htmlFor="MotivoPago">Motivo</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Comentario"
                    value={values.Comentario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Comentario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentario">Comentario</label>
                </span>
              </div>

            </div>
          </div>
        </div>
      </Dialog>

      
    </div>
  );
};

export default MotivosPagoCRUD;
